export default __webpack_public_path__ + "static/media/meetme-active.43c5825c.svg";